import { differenceInYears, differenceInMonths, differenceInDays, parse } from 'date-fns';
import useJwt from "@/auth/jwt/useJwt";

export const getUserData = () => {
  return JSON.parse(localStorage.getItem('userData'))
};
export const hasPermission = (permission) => {
  if (localStorage.getItem('permissions') === null) localStorage.setItem('permissions', JSON.stringify([]))
  return JSON.parse(localStorage.getItem('permissions')).indexOf(permission) !== -1;
};
export const setPermissions = (user) => {
  const permissions = user.all_permissions.map(permission => permission.codename)
  localStorage.setItem('permissions', JSON.stringify(permissions))
}
export const setuserData = (response, abilities) => {
  const user = response.user

  const userData = {
    account_company: response.account_company,
    email: user.email,
    first_name: user.first_name,
    groups: user.groups,
    id: user.id,
    is_active: user.is_active,
    accept_marketing: user.accept_marketing ? user.accept_marketing : true,
    is_verified: user.is_verified ? user.is_verified : false,
    is_superuser: user.is_superuser ? user.is_superuser : false,
    last_name: user.last_name,
    main_group: user.main_group,
    max_views: user.max_views,
    user_permissions: user.user_permissions,
    username: user.username,
    ability: abilities,
    profile_image: user.profile_image,
    question_text: user.question_text,
    has_payment_data: user.has_payment_data,
    payment_data: user.has_payment_data ? user.payment_data : null,
    current_plan: user.current_plan,
    meta_info: user.meta_info,
    notification_settings: user.notification_settings,
    balance: user.balance,
    banned_for_proposal: user.banned_for_proposal
  }
  localStorage.setItem('accept_tyc', user.accept_tyc ? user.accept_tyc : false);
  localStorage.setItem('userData', JSON.stringify(userData))
};
export const updateNotificationUserData = (notification) => {
  const user = JSON.parse(localStorage.getItem('userData'));
  user.notification_settings = notification;
  localStorage.setItem('userData', JSON.stringify(user));
};
export const calculateAntiquity = (dateString) => {
  
  const parsedDate = parse(dateString, 'dd-MM-yyyy', new Date());
  
  const now = new Date();
  
  const years = differenceInYears(now, parsedDate);
  const months = differenceInMonths(now, parsedDate) % 12;
  const days = differenceInDays(now, parsedDate) % 30;

  return {
    years,
    months,
    days
  };
};
export const isOOH = () => {
  return window.location.href.includes('outofhome');
};
export const updatePaymentData = (payment_data) => {
  const user = getUserData()
  user.has_payment_data = true
  user.payment_data = payment_data
  localStorage.setItem('userData', JSON.stringify(user))
};
export const removeLocal = (router) => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userData');

  router.push({ name: 'auth-login' });
};
export const checkVerified = () => {
  const user = getUserData()
  return user.is_verified
};

export const logout = () => {
  // Remove userData from localStorage

  localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
  localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

  // Remove userData from localStorage
  localStorage.removeItem("userData");
  localStorage.removeItem("accept_tyc");
  localStorage.removeItem('permissions');
  localStorage.removeItem('token_device');
  localStorage.removeItem('has_showed_notification_modal');
  localStorage.removeItem('routes_visited');
  localStorage.removeItem('stepperInfo');
  localStorage.removeItem('steps');
  localStorage.clear();

  // Redirect to login page
  // this.$router.push({ name: "auth-login" });
  window.location.replace("/login");
}